//Import Css
import "bootstrap";
// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "simple-line-icons/css/simple-line-icons.css";
import "flag-icon-css/css/flag-icon.min.css";
import "bootstrap-social/bootstrap-social.css";
import "flatpickr/dist/flatpickr.css";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import "vuetify/dist/vuetify.min.css";
import "element-ui/lib/theme-chalk/index.css";

//import css
import "@/assets/default/app.min.css";
// import '@/assets/default/style-responsive.min.css'
import "@/assets/default/theme/orange.min.css";
// import '@/assets/default/style.css'

// import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import mixins
import mixinMethods from "@/assets/mixin/methods.js";

import Vue from "vue";
import App from "./App.vue";

//for older browser compatibility
import "es6-promise";

import VueX from "vuex";

//routes
import router from "./Options/router.js";

// apm plugin
import { ApmVuePlugin } from "@elastic/apm-rum-vue";

//store
import storeOptions from "./store/store.js";

//axios
import Axios from "axios";
Axios.defaults.baseURL = env.urlStart;
Vue.prototype.$http = Axios; // to run axios, just use this.$http

//vue bootstrap
import VueBootstrap from "bootstrap-vue";

//vuetify
import Vuetify from "vuetify";

//VueInsProgress
import VueInsProgressBar from "vue-ins-progress-bar";

//import SweetAlert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

//import googlemaps
import * as VueGoogleMaps from "vue2-google-maps";

//import vue meta
import VueMeta from "vue-meta";

//import env
import env from "./env.js";

//add panel for global use
import VuePanel from "./plugins/panel/";

//import json to excel converter
import JsonExcel from "vue-json-excel";

import MultiSelect from "vue-multiselect";
import flatPickr from "vue-flatpickr-component";
import vueUniversalTable from "@/components/table/vue_universal_table.vue";
import vueUniversalTableQrcode from "@/components/table/vue_universal_table_qrcode.vue";
import VueSignaturePad from "vue-signature-pad";

//Vue use
Vue.use(Vuetify);
Vue.use(VueX);
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueBootstrap);
Vue.use(VueInsProgressBar, {
  position: "fixed",
  show: true,
  height: "3px",
});
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB-HQz5XF0qUyvvRjUjQU1raI_JT5gdNws",
    libraries: "places",
  },
});
Vue.use(VueSignaturePad);
Vue.use(VuePanel);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.component("vue-universal-table", vueUniversalTable);
Vue.component("vue-universal-table-qrcode", vueUniversalTableQrcode);
Vue.component("flat-pickr", flatPickr);
Vue.component("MultiSelect", MultiSelect);

Vue.mixin({
  methods: mixinMethods,
});

import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.config.productionTip = env.productionMode;

const store = new VueX.Store(storeOptions);

//inject Vue to Id = App
new Vue({
  el: "#app",
  store,
  router: router,
  // Vuetify,
  render: (h) => h(App),
});

//Google Analytics
import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: { id: env.gaId },
  },
  router
);

Vue.use(ApmVuePlugin, {
  router,
  config: {
    serviceName: env.serviceName ? env.serviceName : "mpm-dashboard",
    // agent configuration
    serviceVersion: "1.0.0",
    environment: env.environment ? env.environment : "development",
    serverUrl: env.serverUrl ? env.serverUrl : "http://localhost:8200",
  },
});

function logout() {
  //delete token
}
